/* JDC — Hero / Banner principal: carrusel con autoplay, crossfade y puntos */
(function () {
  function initHero(root) {
    var slides = [].slice.call(root.querySelectorAll('.jdc-hero__slide'));
    var dotsWrap = root.querySelector('[data-jdc-hero-dots]');

    // Ajusta el alto del hero a la proporcion real del medio activo (sin recortes).
    // Solo aplica cuando NO es pantalla completa.
    function activeMedia(idx) {
      var s = slides[idx];
      if (!s) return null;
      var mobile = window.matchMedia('(max-width:768px)').matches;
      return s.querySelector(mobile ? '.jdc-hero__bg--mb' : '.jdc-hero__bg--dk') || s.querySelector('.jdc-hero__bg');
    }
    function mediaRatio(m) {
      if (!m) return 0;
      if (m.tagName === 'VIDEO') return (m.videoWidth && m.videoHeight) ? m.videoWidth / m.videoHeight : 0;
      var mw = parseFloat(m.getAttribute('width')), mh = parseFloat(m.getAttribute('height'));
      if (mw && mh) return mw / mh;
      return (m.naturalWidth && m.naturalHeight) ? m.naturalWidth / m.naturalHeight : 0;
    }
    var curIdx = 0;
    function sizeHero() {
      if (root.classList.contains('jdc-hero--full')) return;
      var m = activeMedia(curIdx);
      var r = mediaRatio(m);
      if (!r) { root.style.height = ''; root.style.minHeight = ''; return; }
      root.style.minHeight = '0';
      root.style.height = Math.round(root.clientWidth / r) + 'px';
    }
    root.querySelectorAll('video').forEach(function (v) {
      v.addEventListener('loadedmetadata', sizeHero);
    });
    var srt;
    window.addEventListener('resize', function () { clearTimeout(srt); srt = setTimeout(sizeHero, 120); });
    window.addEventListener('load', sizeHero);

    // Reproduce el video del slide activo y pausa los del resto
    function setVideos(activeIdx) {
      slides.forEach(function (s, idx) {
        [].slice.call(s.querySelectorAll('video')).forEach(function (v) {
          if (idx === activeIdx) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      });
    }

    if (slides.length < 2) {
      if (dotsWrap) dotsWrap.style.display = 'none';
      setVideos(0);
      sizeHero();
      return;
    }
    var i = 0;
    var delay = (parseFloat(root.getAttribute('data-autoplay')) || 0) * 1000;
    var timer = null;
    var dots = [];

    if (dotsWrap) {
      slides.forEach(function (s, idx) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jdc-hero__dot' + (idx === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Banner ' + (idx + 1));
        b.addEventListener('click', function () { go(idx); restart(); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
      curIdx = i;
      setVideos(i);
      sizeHero();
    }
    function next() { go(i + 1); }
    function start() { if (delay > 0) timer = setInterval(next, delay); }
    function restart() { if (timer) clearInterval(timer); start(); }

    root.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    root.addEventListener('mouseleave', restart);
    setVideos(0);
    sizeHero();
    start();
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function initCountdown(el) {
    var target = new Date(el.getAttribute('data-deadline')).getTime();
    if (isNaN(target)) { el.style.display = 'none'; return; }
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'),
        m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    function tick() {
      var diff = target - Date.now();
      if (diff < 0) diff = 0;
      var dd = Math.floor(diff / 86400000),
          hh = Math.floor((diff % 86400000) / 3600000),
          mm = Math.floor((diff % 3600000) / 60000),
          ss = Math.floor((diff % 60000) / 1000);
      if (d) d.textContent = dd;
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
    }
    tick();
    setInterval(tick, 1000);
  }

  // Ajusta el hero a pantalla completa DESCONTANDO las barras que haya arriba
  // (barra de aniversario, barra de login, etc.), para que el CTA inferior no se salga.
  function fitHero() {
    document.querySelectorAll('.jdc-hero--full').forEach(function (h) {
      var absTop = h.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0);
      var avail = window.innerHeight - absTop;
      if (avail > 320) h.style.minHeight = avail + 'px';
    });
  }

  function boot() {
    document.querySelectorAll('[data-jdc-hero-slider]').forEach(initHero);
    document.querySelectorAll('[data-jdc-countdown]').forEach(initCountdown);
    fitHero();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fitHero, 150); });
    window.addEventListener('load', fitHero);
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();
